import React from "react";
import PropTypes from "prop-types";
import Table from "../Table";
import { useSpecialRouteBusBlocks } from "../../hooks/use-fetch-special-route-bus-blocks";
import { useFetchSpecialsBusBlocksByNumber } from "../../hooks/use-fetch-specials-bus-blocks-by-number";

export const SpecialServicesContext = React.createContext();

const SpecialServices = ({ setApiErrors }) => {
  const fetchSpecialsBusBlocksByNumber = useFetchSpecialsBusBlocksByNumber();
  const fetchSpecialRouteBusBlocks = useSpecialRouteBusBlocks();

  return (
    <div>
      <section className="container">
        <Table
          TableContext={SpecialServicesContext}
          fetchBusBlocks={fetchSpecialRouteBusBlocks}
          fetchBusBlocksByNumber={fetchSpecialsBusBlocksByNumber}
          setApiErrors={setApiErrors}
          isSpecial={true}
        />
      </section>
    </div>
  );
};

SpecialServices.propTypes = {
  setApiErrors: PropTypes.func,
};

export default SpecialServices;
